module.exports = __webpack_public_path__ + "img/senalando-izqpa.png.037588eb.webp";